import React from "react";
import { useTranslation } from "react-i18next";
import FlatList from "src/components/FlatList";
import Link from "src/components/Link";
import ListItem from "src/components/lists/list-items/ListItem";
import Stars from "src/components/Stars";
import TitleCut from "src/components/TitleCut";
import useGet from "src/hooks/rest/useGet";
import useAuth from "src/hooks/selectors/useAuth";

interface RegistrationListProps {
	limit: number;
	query?: string;
}

const RegistrationList = ({ limit, query }: RegistrationListProps) => {
	const { t } = useTranslation("lists", {
		keyPrefix: "registration-list",
	});
	const auth = useAuth();
	const [result, loading, { pagination }] = useGet(
		`/${auth.type}/registrations?limit=${limit}&include[]=task&include[]=user&${query}`,
		{ data: [] },
		true
	);
	const { data } = result;

	return (
		<FlatList
			noInfiniteScroll
			gap={16}
			{...{ loading, pagination }}
			data={data || []}
			empty={{
				title: t("empty.title"),
			}}
			renderItem={(row: any) => (
				<ListItem
					to={`/tasks/${row?.task?.hid}/show/${row?.hid}`}
					bordered
					align="start"
					key={row.id + row.hid}
				>
					<ListItem.Avatar size="small" src={row?.user?.avatar} />
					<ListItem.Content className="gap-2">
						<div className="flex flex-wrap gap-1 justify-between">
							{auth?.has_subscription && (
								<ListItem.Title>
									{row?.user?.full_name}
								</ListItem.Title>
							)}
							<div className="mr-8">
								{row?.user?.review > 0 && (
									<Stars rating={row?.user?.review} />
								)}
							</div>
						</div>
						<ListItem.Text variant="small">
							{row.excerpt}
							<Link
								to={`/tasks/${row?.task?.hid}/show/${row?.hid}`}
								className="underline mt-1 block"
							>
								<TitleCut className="max-w-[180px]">
									{row?.task?.title}
								</TitleCut>
							</Link>
						</ListItem.Text>
					</ListItem.Content>
				</ListItem>
			)}
		/>
	);
};

RegistrationList.defaultProps = {
	limit: 4,
};

export default RegistrationList;
